import { ListItemDecorator, Tab, TabList, Tabs, tabClasses } from '@mui/joy';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import EEGMenuIcon from '@MP/icon/EEGMenuIcon';
import HRVMenuIcon from '@MP/icon/HRVMenuIcon';
import ScanMiniIcon from '@MP/icon/ScanMiniIcon';
import SleepMenuIcon from '@MP/icon/SleepMenuIcon';
import SummaryMenuIcon from '@MP/icon/SummaryMenuIcon';
import SurveyMenuIcon from '@MP/icon/SurveyMenuIcon';
import StimHomeMenuIcon from '@MP/shared/icon/StimHomeMenuIcon';

const MENUS = [
  {
    key: 'SUMMARY',
    getIcon: (active: boolean) => <SummaryMenuIcon primary={active} />,
    label: '대시보드 ',
  },
  {
    key: 'SURVEY',
    getIcon: (active: boolean) => <SurveyMenuIcon primary={active} />,
    label: '척도검사 ',
  },
  {
    key: 'STIM',
    getIcon: (active: boolean) => <StimHomeMenuIcon primary={active} />,
    label: 'STIM ',
  },
  {
    key: 'SLEEP',
    getIcon: (active: boolean) => <SleepMenuIcon primary={active} />,
    label: '수면일기 ',
  },
  // {
  //   key: 'SCAN_MINI',
  //   getIcon: (active: boolean) => <ScanMiniIcon type={active ? 'primary' : 'dark'} />,
  //   label: '수면 측정 ',
  // },
  // {
  //   key: 'EEG',
  //   getIcon: (active: boolean) => <EEGMenuIcon primary={active} />,
  //   label: 'EEG ',
  // },
  // {
  //   key: 'HRV',
  //   getIcon: (active: boolean) => <HRVMenuIcon primary={active} />,
  //   label: 'HRV ',
  // },
];
const MenuTabs = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // 현재 경로에서 활성 탭 키를 파생 — survey(및 그 외)가 기본
  const pathname = location.pathname.toLowerCase();
  const activeTab = pathname.startsWith('/patient/summary')
    ? 'SUMMARY'
    : pathname.startsWith('/patient/eeg')
      ? 'EEG'
      : pathname.startsWith('/patient/hrv')
        ? 'HRV'
        : pathname.startsWith('/patient/sleep')
          ? 'SLEEP'
          : pathname.startsWith('/patient/scan-mini')
            ? 'SCAN_MINI'
            : pathname.startsWith('/patient/stim-home')
              ? 'STIM'
              : 'SURVEY';

  const handleChange = (tabKey: string) => {
    switch (tabKey) {
      case 'SUMMARY':
        navigate('/patient/summary');
        break;
      case 'EEG':
        navigate('/patient/eeg/history');
        break;
      case 'HRV':
        navigate('/patient/hrv/history');
        break;
      case 'SLEEP':
        navigate('/patient/sleep');
        break;
      case 'SCAN_MINI':
        navigate('/patient/scan-mini');
        break;
      case 'STIM':
        navigate('/patient/stim-home');
        break;
      default:
        navigate('/patient/survey');
    }
  };

  return (
    <Tabs value={activeTab} onChange={(_, v) => handleChange(String(v))} sx={{ background: '#FFF' }}>
      <TabList
        disableUnderline
        sx={{
          height: '55px',
          [`&& .${tabClasses.root}`]: {
            bgcolor: 'transparent',
            fontWeight: 600,
            '&:hover': {
              bgcolor: 'transparent',
            },
            [`&.${tabClasses.selected}`]: {
              color: 'primary.plainColor',
            },
            [`&.${tabClasses.selected}::after`]: {
              left: '16px',
              right: '16px',
            },
          },
        }}>
        {MENUS.map((v) => (
          <Tab value={v.key} key={v.key}>
            <ListItemDecorator>{v.getIcon(activeTab === v.key)}</ListItemDecorator>
            {v.label}
          </Tab>
        ))}
      </TabList>
    </Tabs>
  );
};

export default MenuTabs;
